import { render, staticRenderFns } from "./MyShippingDetails.vue?vue&type=template&id=12510672&scoped=true&"
import script from "./MyShippingDetails.vue?vue&type=script&async=true&lang=js&"
export * from "./MyShippingDetails.vue?vue&type=script&async=true&lang=js&"
import style0 from "./MyShippingDetails.vue?vue&type=style&index=0&id=12510672&lang=scss&scoped=true&"
import style1 from "./MyShippingDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12510672",
  null
  
)

export default component.exports